import React from 'react';
import { Link } from 'react-router-dom';
import { PublicLayout } from '../components/PublicLayout';
import { Users, QrCode, ShieldCheck } from 'lucide-react';

export default function DirektoriPesilat() {
  return (
    <PublicLayout>
      <div className="bg-[#0B0B0B] text-white py-14">
        <div className="h-0.5 bg-gradient-to-r from-[#D71920] via-[#FFD21F] to-[#D71920] -mt-14 mb-14" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <p className="text-xs text-[#FFD21F] font-bold tracking-widest uppercase mb-2">Utama / Direktori</p>
          <h1 className="text-3xl sm:text-4xl font-extrabold" data-testid="direktori-pesilat-title">Direktori Pesilat</h1>
          <p className="text-[#999] mt-2 text-sm max-w-lg">
            Rekod pesilat yang telah disahkan keahliannya oleh Rumpun Silat Sarawak.
          </p>
        </div>
      </div>

      <section className="bg-white py-16 sm:py-24">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center">
          <div className="w-16 h-16 bg-[#F7F7F7] border border-[#E5E5E5] rounded-full flex items-center justify-center mx-auto mb-8">
            <Users size={28} className="text-[#D4AF37]" />
          </div>
          <h2 className="text-2xl sm:text-3xl font-extrabold text-[#0B0B0B] mb-4">
            Direktori Dalam Proses Kemaskini
          </h2>
          <p className="text-[#555] text-sm sm:text-base leading-relaxed mb-8 max-w-xl mx-auto">
            Direktori Pesilat Rumpun Silat Sarawak sedang melalui proses pengesahan dan kemaskini data secara berfasa.
            Hanya maklumat yang telah disahkan oleh Sekretariat akan dipaparkan di sini.
          </p>

          {/* Features */}
          <div className="grid sm:grid-cols-3 gap-5 mt-12 text-left">
            {[
              { icon: <ShieldCheck size={20} />, title: 'Data Disahkan', desc: 'Hanya pesilat yang telah disahkan keahliannya oleh Sekretariat RSS akan tersenarai.' },
              { icon: <QrCode size={20} />, title: 'QR Verifikasi', desc: 'Setiap ahli dibekalkan kod QR untuk pengesahan identiti yang selamat dan pantas.' },
              { icon: <Users size={20} />, title: 'Privasi Terpelihara', desc: 'Maklumat sensitif seperti nombor IC dan alamat penuh tidak didedahkan kepada umum.' },
            ].map((f, i) => (
              <div key={i} className="bg-[#F7F7F7] border border-[#E5E5E5] p-6 rounded" data-testid={`pesilat-feature-${i}`}>
                <div className="w-8 h-8 bg-[#D4AF37]/15 rounded flex items-center justify-center text-[#9a7b00] mb-4">
                  {f.icon}
                </div>
                <h3 className="font-bold text-[#0B0B0B] text-sm mb-2">{f.title}</h3>
                <p className="text-xs text-[#777] leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-12 p-6 bg-[#FFFBF0] border border-[#D4AF37]/30 rounded text-left">
            <p className="text-sm text-[#7a6200] leading-relaxed">
              <strong>Untuk pesilat yang ingin menyemak rekod:</strong> Sila hubungi perguruan anda atau
              Sekretariat RSS Sarawak untuk maklumat lanjut tentang status keahlian anda.
            </p>
          </div>

          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link to="/verify" className="inline-flex items-center gap-2 bg-[#D4AF37] hover:bg-[#c49e2a] text-[#0B0B0B] text-sm font-semibold px-5 py-2.5 rounded transition-colors" data-testid="qr-verify-btn">
              <QrCode size={15} /> Imbas Kod QR
            </Link>
            <Link to="/register-member" className="inline-flex items-center gap-2 border border-[#E5E5E5] hover:border-[#0B0B0B] text-[#555] hover:text-[#0B0B0B] text-sm font-medium px-5 py-2.5 rounded transition-colors">
              Daftar Keahlian
            </Link>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
